export default __webpack_public_path__ + "static/media/logo-surf.2a7eda5e.png";